import {
  FETCH_COIN_SETTING_SUCCEED,
  FETCH_MARKET,
  FETCH_MARKET_SUCCEED,
  FETCH_MARKET_FAILED,
  FETCH_ALL_COIN_SUCCEED,
} from '../actions/setting_data/action_types';

export default (state = {
  coinSettings: [],
  currencyMarkets: {},
  coins: [],
  limitWithdrawals: [],
  isTableLoading: false,
}, action) => {
  switch (action.type) {
    case FETCH_COIN_SETTING_SUCCEED:
      return {
        ...state,
        coinSettings: action.params.data,
      };

    case FETCH_ALL_COIN_SUCCEED:
      const coins = window._.reduce(action.params.data, (result, item) => {
        result[item.coin] = item;
        return result;
      }, {});
      return {
        ...state,
        coins,
      };

    case FETCH_MARKET:
      return {
        ...state,
        isTableLoading: true,
      };
    case FETCH_MARKET_SUCCEED:
      const currencyMarkets = window._.reduce(action.params.data, (result, item, market) => {
        const pair = `${market}`.split(':');
        const coin = pair[0];
        const currency = pair[1];

        if (window._.isEmpty(result[currency])) {
          result[currency] = [];
        }

        item.coin = coin;
        item.currency = currency;
        result[currency].push(item);

        return result;
      }, {});

      return {
        ...state,
        currencyMarkets,
        isTableLoading: false,
      };
    case FETCH_MARKET_FAILED:
      return {
        ...state,
        isTableLoading: true,
      };
    default:
      return {
        ...state,
      };
  }
};
